
<template>
  <header class="sf-account-header">
    <router-link to="/" class="sf-account-brand" aria-label="StoryFaith account home">
      <img src="/static/communities/header-logo.png" alt="StoryFaith">
    </router-link>

    <TopSearch />

    <div class="sf-account-navigation">
      <router-link v-if="!isManagingCommunity" to="/communities" class="sf-account-communities">
        My communities
      </router-link>

      <details ref="dropdown" class="sf-account-dropdown"
        @keydown.esc.prevent.stop="closeAndFocus">
        <summary ref="trigger" aria-label="Open account navigation">
          <img v-if="avatar" :src="avatar" alt="">
          <span v-else class="sf-account-initials">{{ initials }}</span>
          <span class="sf-account-chevron" aria-hidden="true">⌄</span>
        </summary>
        <div class="sf-account-menu" @click="close">
          <div class="sf-account-identity">
            <strong>{{ displayName }}</strong>
            <span v-if="userData.email">{{ userData.email }}</span>
          </div>
          <nav aria-label="Your account">
            <router-link to="/" class="sf-account-profile-switch">
              {{ isManagingCommunity ? 'Switch to user profile →' : 'Your StoryFaith' }}
            </router-link>
            <router-link v-if="!isManagingCommunity" to="/profile/edit">Edit profile</router-link>
            <a href="/discover/" class="sf-account-communities">Explore</a>
            <router-link to="/logout" class="sf-account-signout">Sign out</router-link>
          </nav>
        </div>
      </details>
    </div>
  </header>
</template>

<script>
import TopSearch from '../index/TopSearch.vue'
export default {
  name: 'AccountHeader',
  components: {TopSearch},
  props: { userData: { type: Object, required: true } },
  computed: {
    isManagingCommunity () {
      return this.$route.path.startsWith('/community-manager/')
    },
    displayName () {
      return [this.userData.first_name, this.userData.last_name]
        .filter(Boolean).join(' ') || this.userData.username || 'Your account'
    },
    initials () {
      return this.displayName.split(/\s+/).slice(0, 2)
        .map(part => part.charAt(0).toUpperCase()).join('')
    },
    avatar () {
      return (this.userData.profile || {}).pic || ''
    }
  },
  watch: {
    $route () { this.close() }
  },
  mounted () {
    document.addEventListener('click', this.outsideClick)
    document.addEventListener('focusin', this.outsideFocus)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.outsideClick)
    document.removeEventListener('focusin', this.outsideFocus)
  },
  methods: {
    close () {
      if (this.$refs.dropdown) this.$refs.dropdown.open = false
    },
    closeAndFocus () {
      this.close()
      this.$refs.trigger.focus()
    },
    outsideClick (event) {
      if (!this.$refs.dropdown.contains(event.target)) this.close()
    },
    outsideFocus (event) {
      if (!this.$refs.dropdown.contains(event.target)) this.close()
    }
  }
}
</script>

<style scoped>
.sf-account-header {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px; padding: 16px 28px; background: #222;
  color: #fff; font-family: 'Open Sans', sans-serif;
  position: relative; z-index: 30;
}
.sf-account-brand img { display: block; width: 145px; height: auto; }
.sf-account-navigation { display: flex; align-items: center; gap: 24px; }
.sf-account-communities { color: white; font-size: 13px; text-decoration: none; }
.sf-account-dropdown { position: relative; }
.sf-account-dropdown summary {
  display: flex; align-items: center; gap: 8px;
  cursor: pointer; list-style: none; border-radius: 24px;
}
.sf-account-dropdown summary::-webkit-details-marker { display: none; }
.sf-account-dropdown summary img, .sf-account-initials {
  width: 38px; height: 38px; border-radius: 50%; object-fit: cover;
}
.sf-account-initials {
  display: grid; place-items: center; background: #fff6c2;
  color: #222222; font-size: 13px; font-weight: 700;
}
.sf-account-menu {
  position: absolute; right: 0; top: calc(100% + 12px);
  width: 270px; max-width: calc(100vw - 32px);
  background: #fff; color: #222222; border: 1px solid #e5e3d8;
  border-radius: 12px; box-shadow: 0 12px 32px #0002; padding: 8px;
}
.sf-account-identity { padding: 14px; border-bottom: 1px solid #e5e3d8; }
.sf-account-identity strong, .sf-account-identity span { display: block; overflow-wrap: anywhere; }
.sf-account-identity strong { font-size: 14px; }
.sf-account-identity span { font-size: 12px; color: #68645b; margin-top: 5px; }
.sf-account-menu nav a {
  display: block; padding: 12px 14px; margin: 4px 0;
  border-radius: 8px; font-size: 13px; text-decoration: none;
}
.sf-account-menu nav a:hover { background: #fff6c2; }
.sf-account-menu .sf-account-signout { border-top: 1px solid #e5e3d8; margin-top: 8px; }
.sf-account-header :focus-visible { outline: 3px solid #ffd400; outline-offset: 3px; }
@media (max-width: 600px) {
  .sf-account-header { padding: 14px 16px; }
  .sf-account-brand img { width: 120px; }
  .sf-account-navigation { gap: 14px; }
  .sf-account-communities { font-size: 11px; }
}

/* Readable links on charcoal */
.sf-account-header .sf-account-communities,
.sf-account-header .sf-account-chevron {
  color: #fff !important;
}
.sf-account-header .sf-account-menu nav a {
  color: #222222 !important;
}

</style>
